<template>
  <InputDateUnica
    :key="filtro.filtro"
    :campo="filtro"
    :text="text"
    :path="path"
    @update:text="aoAtualizarTexto"
    @dateSelected="aplicarFiltro"
    @dateBlanked="limparValor"
    @dateCleared="limparFiltro"
  />
</template>
<script>
import InputDateUnica from '../../components/InputDateUnica.vue';

export default {
  name: 'DataChegada',
  components: {
    InputDateUnica
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      text: ''
    };
  },
  mounted() {
    const valorAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    if (valorAplicado) {
      this.text = valorAplicado;
    }
  },
  beforeUnmount() {
    this.text = '';
  },
  methods: {
    aplicarFiltro(data) {
      if (!data) return;

      this.text = data;
      this.$aplicaFiltroEmURL(this.filtro.filtro, data, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: data
      });
    },
    limparFiltro() {
      this.text = '';
      this.$removeFiltroDaURL(this.filtro.filtro, this.path);
      this.$store.commit('removeFiltro', this.filtro.filtro);
      this.$filtroDb.removeFiltro(this.path, this.filtro.filtro)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));
    },
    limparValor() {
      this.text = '';
      this.$removeFiltroDaURL(this.filtro.filtro, this.path);
      this.$store.commit('removeFiltroAplicado', this.filtro.filtro);
    },
    aoAtualizarTexto(texto) {
      this.text = texto;
    }
  }
};
</script>
